import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelector", "supplierContainer", "supplierSelector"]

  connect() {
    this.toggleSupplierSelector()
  }

  toggleSupplierSelector() {
    const isSupplier = this.roleSelectorTarget.value === "supplier_admin"
    const action = isSupplier ? "remove" : "add"
    this.supplierContainerTarget.classList[action]("d-none")
    this.supplierSelectorTarget.required = isSupplier

    if (!isSupplier) {
      this.supplierSelectorTarget.value = ""
    }
  }
}
